import { createStore } from 'vuex'

import Template from '@/Libs/Template/Template.js'

import Loading from '@/Libs/Store/Loading.js'
import AccessControl from '@/Libs/Store/AccessControl.js'
import Sidebar from '@/Libs/Store/Sidebar.js'

var modules = Template;

modules.loading = Loading
modules.accessControl = AccessControl
modules.sidebar = Sidebar

var store = createStore({
  modules,
  // Enable strict mode in development to get a warning
  // when mutating state outside of a mutation.
  // https://vuex.vuejs.org/guide/strict.html
  strict: process.env.NODE_ENV !== 'production',
})

export default store